import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { VKDirektutbyteDTO } from "../../models/tradslag/direktutbyte-models";

export class UpdateDirektutbyteCommand extends BasicCommand<UpdateDirektutbyteCommand> {
    readonly direktutbyte: VKDirektutbyteDTO;
    readonly atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateDirektutbyteCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Direktutbyte";

    get primaryKey(): IPrimaryKey<UpdateDirektutbyteCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, direktutbyte: VKDirektutbyteDTO) {
        super(UpdateDirektutbyteCommand.$type, UpdateDirektutbyteCommand.$groupKey, CommandType.Replace);
        this.direktutbyte = direktutbyte;
        this.atgardGuid = atgardGuid;
    }
}
